var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"brand"},[_vm._v("All content © copyright "+_vm._s(new Date().getFullYear())+" Lane Clark & Peacock LLP. All rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }